export default __webpack_public_path__ + "static/media/home_hero.65ebf3ff.svg";